import { render, staticRenderFns } from "./Sop.vue?vue&type=template&id=57284b82&scoped=true"
import script from "./Sop.vue?vue&type=script&lang=js"
export * from "./Sop.vue?vue&type=script&lang=js"
import style0 from "./Sop.vue?vue&type=style&index=0&id=57284b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57284b82",
  null
  
)

export default component.exports